export const OTP_CODE_REGEX = /^\d{6,8}$/;
export const RECOVERY_CODE_REGEX = /^[A-Za-z0-9]{5}-?[A-Za-z0-9]{5}$/;
export const PASSWORD_MIXED_CASE_REGEX = /(?=.*[a-z])(?=.*[A-Z])/;
export const PASSWORD_DIGIT_REGEX = /\d/;
export const PASSWORD_SYMBOL_REGEX = /[^A-Za-z0-9]/;
export const PASSWORD_SETUP_MIN_LENGTH = 8;
export const PASSWORD_RECOMMENDED_MIN_LENGTH = 12;
export const normalizeSecurityCode = (value) => value.trim();
export const normalizeRecoveryCode = (value) => normalizeSecurityCode(value).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
export const formatRecoveryCode = (value) => {
    const normalized = normalizeRecoveryCode(value);
    if (normalized.length <= 5)
        return normalized;
    return `${normalized.slice(0, 5)}-${normalized.slice(5, 10)}`;
};
export const isOtpCode = (value) => OTP_CODE_REGEX.test(normalizeSecurityCode(value));
export const isRecoveryCode = (value) => RECOVERY_CODE_REGEX.test(normalizeSecurityCode(value));
export const hasPasswordMixedCase = (value) => PASSWORD_MIXED_CASE_REGEX.test(value);
export const hasPasswordDigit = (value) => PASSWORD_DIGIT_REGEX.test(value);
export const hasPasswordSymbol = (value) => PASSWORD_SYMBOL_REGEX.test(value);
export const evaluatePasswordStrength = (password) => {
    const value = password.trim();
    if (!value) {
        return { score: 0, level: 'weak' };
    }
    let score = 0;
    if (value.length >= PASSWORD_SETUP_MIN_LENGTH)
        score += 1;
    if (value.length >= PASSWORD_RECOMMENDED_MIN_LENGTH)
        score += 1;
    if (hasPasswordMixedCase(value))
        score += 1;
    if (hasPasswordDigit(value))
        score += 1;
    if (hasPasswordSymbol(value))
        score += 1;
    if (score <= 1)
        return { score, level: 'weak' };
    if (score === 2)
        return { score, level: 'fair' };
    if (score <= 4)
        return { score, level: 'good' };
    return { score, level: 'strong' };
};
export const isPasswordStrongEnough = (password) => evaluatePasswordStrength(password).score >= 3;
